export default __webpack_public_path__ + "static/media/paypal.e4ee6325.png";